/* Wubs kollektion – filter, sortering, dölj-filter.
   Filtren submittas som GET (siduppdatering) – robust och SEO-vänligt.
   collection.filters kommer från Search & Discovery; är den tom finns bara sortering. */
(function () {
  const root = document.querySelector('[data-wubs-collection]');
  if (!root) return;

  /* Sticky verktygsrad: offseten måste vara headerns FAKTISKA höjd, annars ligger raden
     antingen under headern eller lämnar en glipa. Headern byter höjd mellan brytpunkter,
     så värdet mäts i stället för att hårdkodas.
     ⚠️ height, INTE getBoundingClientRect().bottom – bottom beror på scrollpositionen, och
     skriptet kan köra efter att webbläsaren återställt en scroll. */
  const header = document.querySelector('.wubs-header');
  const toolbar = root.querySelector('.wubs-collection__toolbar');
  if (header || toolbar) {
    const matHojder = () => {
      if (header) {
        const h = Math.round(header.getBoundingClientRect().height);
        if (h > 0) document.documentElement.style.setProperty('--wubs-hh', h + 'px');
      }
      /* Filtren ligger under den sticky verktygsraden och behöver dess höjd som extra offset.
         Mäts av samma skäl som headern: raden växer om texten radbryts på smala desktopbredder. */
      if (toolbar) {
        const t = Math.round(toolbar.getBoundingClientRect().height);
        if (t > 0) root.style.setProperty('--wc-toolbar-h', t + 'px');
      }
    };
    matHojder();
    window.addEventListener('resize', matHojder);
    window.addEventListener('load', matHojder);
  }

  const layout = root.querySelector('.wubs-collection__layout');
  const form = root.querySelector('[data-wubs-facets]');
  const sortdd = root.querySelector('[data-wubs-sortdd]');
  const toggle = root.querySelector('[data-wubs-filter-toggle]');
  const toggleLabel = root.querySelector('[data-filter-toggle-label]');

  /* Bygg URL från filterformuläret + behåll aktuell sortering. */
  function buildUrl(extra) {
    const params = new URLSearchParams();
    if (form) {
      form.querySelectorAll('input, select').forEach((el) => {
        if (!el.name) return;
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        if (el.value === '' || el.value == null) return;
        params.append(el.name, el.value);
      });
    }
    const curSort = new URLSearchParams(location.search).get('sort_by');
    const s = (extra && extra.sort_by) || curSort;
    if (s) params.set('sort_by', s);
    const qs = params.toString();
    return location.pathname + (qs ? '?' + qs : '');
  }

  if (form) {
    form.addEventListener('change', () => { location.href = buildUrl(); });
    form.addEventListener('submit', (e) => { e.preventDefault(); location.href = buildUrl(); });
  }

  /* Egen sorteringsdropdown (ninepine-stil): öppna/stäng, val → navigera, stäng vid klick utanför/Escape. */
  if (sortdd) {
    const sortToggle = sortdd.querySelector('[data-sort-toggle]');
    const sortMenu = sortdd.querySelector('[data-sort-menu]');
    const closeSort = () => {
      sortMenu.hidden = true;
      sortdd.classList.remove('is-open');
      sortToggle.setAttribute('aria-expanded', 'false');
    };
    const openSort = () => {
      sortMenu.hidden = false;
      sortdd.classList.add('is-open');
      sortToggle.setAttribute('aria-expanded', 'true');
    };
    sortToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      if (sortMenu.hidden) openSort(); else closeSort();
    });
    sortdd.querySelectorAll('[data-sort-value]').forEach((opt) => {
      opt.addEventListener('click', () => { location.href = buildUrl({ sort_by: opt.dataset.sortValue }); });
    });
    document.addEventListener('click', (e) => { if (!sortdd.contains(e.target)) closeSort(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSort(); });
  }

  /* Dölj/visa filter. Initialläget bestäms av CSS (desktop öppet, mobil stängt);
     JS läser FAKTISK synlighet så etikett/toggle alltid stämmer, oavsett load-timing. */
  const filters = root.querySelector('[data-wubs-filters]');

  /* Hjulscroll över filtren.
     ⚠️ Lenis (wubs-lenis.js) kapar wheel-events för hela sidan, så en intern scroll-yta får
     INGEN native scroll om den inte är märkt med data-lenis-prevent. Filtren stod inte i
     Lenis PREVENT-lista → hjulet över sidopanelen scrollade sidan i stället för listan.

     ⚠️ Attributet sätts DYNAMISKT, inte statiskt. data-lenis-prevent gör att Lenis släpper
     hjulet helt över elementet – står det kvar när listan får plats på skärmen (små
     kollektioner, hopfällda facetter) fastnar sidan så fort musen är över panelen. Det är
     precis fällan som gjorde att karusellerna medvetet hölls utanför listan i wubs-lenis.js. */
  if (filters) {
    const syncScroll = () => {
      const overflows = filters.scrollHeight > filters.clientHeight + 1;
      filters.toggleAttribute('data-lenis-prevent', overflows);
    };
    syncScroll();
    window.addEventListener('load', syncScroll);
    window.addEventListener('resize', syncScroll);
    /* ⚠️ `toggle` från <details> BUBBLAR INTE – lyssnaren måste ligga i capture-fasen.
       Facetterna fälls ut och in, och då ändras panelens höjd. */
    filters.addEventListener('toggle', syncScroll, true);
  }
  function isVisible() {
    return filters && getComputedStyle(filters).display !== 'none';
  }
  /* Etiketterna kommer från sektionens inställningar (data-label-open/-closed på knappen,
     2026-09-11). Reserven är dagens text – en knapp utan attributen ser ut precis som förut. */
  function etikett(open) {
    const d = toggle ? toggle.dataset : {};
    return open ? (d.labelOpen || 'Dölj filter') : (d.labelClosed || 'Visa filter');
  }
  function setOpen(open) {
    layout.setAttribute('data-filters-open', open ? 'true' : 'false');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (toggleLabel) toggleLabel.textContent = etikett(open);
  }
  /* ⚠️ Knappen renderas INTE när kollektionen saknar filter (Search & Discovery gav inga).
     Utan vakten kastar raden nedan och HELA filen slutar köra – då dör även sortering och
     lenis-vakten ovan, på sidor som såg helt normala ut. */
  if (toggle) {
    // etikett vid load speglar CSS-initialläget
    if (toggleLabel) toggleLabel.textContent = etikett(isVisible());
    toggle.setAttribute('aria-expanded', isVisible() ? 'true' : 'false');
    toggle.addEventListener('click', () => { setOpen(!isVisible()); });
  }
})();
